export enum NeedType {
  HUNGER = 'hunger',
  THIRST = 'thirst',
  FATIGUE = 'fatigue',
  MORALE = 'morale',
}

export interface NeedState {
  value: number;
  max: number;
}

export interface NeedsState {
  [NeedType.HUNGER]: NeedState;
  [NeedType.THIRST]: NeedState;
  [NeedType.FATIGUE]: NeedState;
  [NeedType.MORALE]: NeedState;
}

export interface NeedEffect {
  threshold: number;
  effect: string;
}